"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    addGoalToWrestler: function() {
        return addGoalToWrestler;
    },
    boostWrestlers: function() {
        return boostWrestlers;
    },
    createWrestler: function() {
        return createWrestler;
    },
    deleteWrestler: function() {
        return deleteWrestler;
    },
    duplicateWrestler: function() {
        return duplicateWrestler;
    },
    generateWrestlers: function() {
        return generateWrestlers;
    },
    penaltyWrestlers: function() {
        return penaltyWrestlers;
    },
    processSegmentAppearanceChanges: function() {
        return processSegmentAppearanceChanges;
    },
    removeGoalFromWrestler: function() {
        return removeGoalFromWrestler;
    },
    resetBrandIdForWrestlers: function() {
        return resetBrandIdForWrestlers;
    },
    resetWrestlers: function() {
        return resetWrestlers;
    },
    updateWrestler: function() {
        return updateWrestler;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
const _constants = require("@fedsim/constants");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createWrestler(payload) {
    return {
        type: _types.ADD_WRESTLER,
        payload
    };
}
function duplicateWrestler(payload) {
    return {
        type: _types.DUPLICATE_WRESTLER,
        payload
    };
}
function updateWrestler(payload) {
    return {
        type: _types.UPDATE_WRESTLER,
        payload
    };
}
function resetBrandIdForWrestlers() {
    return {
        type: _types.RESET_BRAND_ID_FOR_WRESTLERS
    };
}
function deleteWrestler(payload) {
    return {
        type: _types.DELETE_WRESTLER,
        payload
    };
}
function resetWrestlers() {
    return {
        type: _types.RESET_WRESTLERS
    };
}
function generateWrestlers(payload) {
    return {
        type: _types.GENERATE_WRESTLERS,
        payload
    };
}
function boostWrestlers({ id }) {
    return {
        type: _types.BOOST_WRESTLER,
        payload: {
            id
        }
    };
}
function penaltyWrestlers({ id }) {
    return {
        type: _types.PENALTY_WRESTLER,
        payload: {
            id
        }
    };
}
function removeGoalFromWrestler({ wrestlerId, championshipId }) {
    return (dispatch, getState)=>{
        const state = getState();
        const { Wrestler } = state.entitiesv2;
        const wrestler = Wrestler?.itemsById?.[wrestlerId];
        if (wrestler) {
            const goalIds = wrestler.goalIds.filter((goalId)=>goalId !== championshipId);
            dispatch(updateWrestler({
                ...wrestler,
                goalIds
            }));
        }
    };
}
function addGoalToWrestler({ wrestlerId, championshipId }) {
    return (dispatch, getState)=>{
        const state = getState();
        const { Championship, Wrestler } = state.entitiesv2;
        //
        const wrestler = Wrestler?.itemsById?.[wrestlerId];
        const championship = Championship?.itemsById?.[championshipId];
        //
        const brandPermitted = championship.brandId === null || championship?.brandId === wrestler?.brandId;
        const genderPermitted = championship.male === wrestler.male;
        //
        if (wrestler && championship && genderPermitted && brandPermitted) {
            const goalIds = [
                championship.id
            ];
            dispatch(updateWrestler({
                ...wrestler,
                goalIds
            }));
        }
    };
}
function processSegmentAppearanceChanges({ id }) {
    return (dispatch, getState)=>{
        const state = getState();
        const changeTypes = _constants.SegmentsMetaCollection.filter((item)=>item.category === "Change")?.map((item)=>item.type);
        const { Production, Segment, Wrestler, Appearance } = state?.entitiesv2;
        const production = Production?.itemsById?.[id];
        const segments = production.segmentIds.map((id)=>Segment.itemsById?.[id]).filter((segment)=>segment && changeTypes.includes(segment.type));
        segments.forEach((segment)=>{
            const appearances = Object.values(Appearance.itemsById).filter((appearance)=>appearance?.segmentId === segment?.id);
            const wrestlerIds = appearances?.map((appearance)=>appearance.wrestlerId);
            const wrestlers = wrestlerIds?.map((id)=>Wrestler.itemsById[id]);
            for (const wrestler of wrestlers){
                let { active, alignment } = wrestler;
                if (segment.type === "ALIGNMENT_CHANGE") {
                    alignment = wrestler.alignment === "GOOD" ? "BAD" : "GOOD";
                } else if (segment.type === "RETIREMENT") {
                    active = wrestler.active === true ? false : true;
                }
                dispatch(updateWrestler({
                    ...wrestler,
                    alignment,
                    active
                }));
            }
        });
    };
}
